const addDevToolsClickListener = (ref, enableDevTools) => {
  let clickListener = null;
  const keyDownHandler = (e) => {
    if (e.metaKey && e.shiftKey && e.altKey && !clickListener) {
      clickListener = (e2) => {
        if (e2.detail === 2) {
          enableDevTools();
        }
      };
      ref?.addEventListener("click", clickListener, { capture: true });
    }
  };
  const keyUpHandler = (e) => {
    if (!e.metaKey || !e.shiftKey || !e.altKey) {
      if (clickListener) {
        ref?.removeEventListener("click", clickListener);
        clickListener = null;
      }
    }
  };
  document.addEventListener("keydown", keyDownHandler);
  document.addEventListener("keyup", keyUpHandler);
  return () => {
    document.removeEventListener("keydown", keyDownHandler);
    document.removeEventListener("keyup", keyUpHandler);
    if (clickListener) {
      ref?.removeEventListener("click", clickListener);
    }
  };
};
export {
  addDevToolsClickListener
};
//# sourceMappingURL=add-dev-tools-click-listener.js.map
